import { useHookstate } from "@hookstate/core";
import { rootComponentsStore } from "../hookstate/rootComponentsStore";

export function useIsTopBarHidden() {
  return useHookstate(rootComponentsStore.isTopBarHidden).get() ?? false;
}
